import Menu from 'antd/es/menu';
import 'antd/es/menu/style/css';

export default Menu;
